export default {
  private: true,
  template_name: 'Float',
  allowed_types: [
    'gh_float',
    'gh_element',
    'gh_tabs',
    'gh_dropdown'
  ],
  model: {
    template_id: 'gh_float',
    name: '',
    icon_id: '',
    class: 'gh_float gh_col_width_12 gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll',
    priority: 0,
    container_id: 0,
    content: []
  },
  html:
    `<div class="gh_float_block gh_float continer_decorator inherit_color">

      <div class="gh_float_block_title_light">
        <span ng-if="item.icon_id" class="gh_float_block_title_light_icon" gh-icon="{{item.icon_id}} 86BEF6 100% normal"></span>
        <span class="gh_float_block_title_light_text">{{item.name}}</span>
      </div>

      <div class="gh_float_block_list" ng-init="lists = item.content"
      dnd-list="lists" dnd-allowed-types="item.allowed_types || ['gh_element']" dnd-drop="dropElement(index, item, external, type, lists)" dnd-inserted="insertedElement()">
        <div ng-if="item.template_id != 'gh_element'" class="gh_float_block_list_item" ng-class="item.class" ng-repeat-start="item in lists"
        ng-include="item.template_id + '_editor_light'"></div>

        <gh-element ng-if="item.template_id == 'gh_element'" ng-class="item.class" ng-repeat-end container-id="{{item.container_id}}" decorator="getElementModelT(item.element_id)" field-id="{{item.element_id}}" elem-src="{{srcForElement}}"
        dnd-draggable="item"
        dnd-effect-allowed="move"
        dnd-moved="$parent.lists.splice($index, 1)"
        dnd-type="item.template_id"></gh-element>
      </div>

      <div style="clear:both"></div>
    </div>`,
  icon: ''
};
